module.exports = __webpack_public_path__ + "img/01_ALMACENAMIENTO_2.84061baa.jpg";